import { LogLevelEnum } from '../../../enum/generic.enums';
import { ProductInputFactorEnum, TripStopTypeEnum } from '../enum/generic.enums';
import { IRsMapOptions } from '../interfaces/mapOptions.interface';

/**
 * Opzioni di configurazione di default per RsMap
 * NON utilizzare direttamente, utilizzare le configurazioni specifiche di ambiente tramite file JSON
 */
export const appRsMapOptionsBase: IRsMapOptions = {
  centerDefault: { description: "MADRID", lat: 40.430948, lng: -3.696722 }, // MADRID
  commands: {
    searchEnabled: true,
    shortcutEnabled: true
  },
  defaultValues: { 'udt': '.' },
  driver: {
    updateListOnTripUpdated: false
  },
  excelExport: 'state',
  fitOnDepotBounds: true,
  fullDuplexCommunication: 'signalr',
  googleApiKey: "AIzaSyDTjuUUom1hDlz2hoNoYUdnjk9tsc2Ne7k",  // https://resdatasrl.sharepoint.com/:x:/r/sites/Routing/_layouts/15/Doc.aspx?sourcedoc=%7B9BE26A3D-8AC1-49CF-AA06-8150FD378895%7D&file=Progetti%20Google%20per%20cartografia%20e%20geocoding.xlsx&action=default&mobileredirect=true&cid=909c7c59-bb08-4978-bbf5-f42a4dc2789f
  layers: {
    base: {
      'disabled': { enabled: true },
      'opencyclemap': { enabled: false },
      'openstreetmap': { enabled: true },
      'googlestreet': { enabled: true },
      'googlehybrid': { enabled: true },
      'googlesat': { enabled: true },
      'googleterrain': { enabled: true },
      'googletraffic': { enabled: true },
      'ptvTileLayer': { enabled: true, showFeatures: true }
    },
    baseDefault: "ptvTileLayer",
    overlay: {
      'destination': { enabled: true, checked: false },
      'destinationSearch': { enabled: true, checked: false },
      'order': { enabled: true, checked: true },
      'terminalDepot': { enabled: true, checked: true },
      'terminalGarage': { enabled: true, checked: true },
      'trip': { enabled: true, checked: true },
      'tripEffective': { enabled: false, checked: false }
    },
  },
  marker: {
    destination: {
      showSellInfoButton: true
    },
    order: {
      tooltip: {
        showNote: true
      },
      useCluster: true
    },
    trip: {
      tooltip: {
        showDeliveryNote: false
      }
    },
    useType: "fa-markers"
  },
  options: {
    autoSavingTimeout: 300,
    canHaveMultipleRouting: false
  },
  order: {
    changeZoneEnabled: true,
    createEnabled: false,
    customPeriodEnabled: false,
    deleteEnabled: false,
    editEnabled: false,
    includeInTrips: false,  // non conteggia nei totali della barra degli ordini quelli nei viaggi
    includePerformance: false,
    multilevelProduct: false,
    tripCreateEnabled: {
      checkDepot: LogLevelEnum.WARNING,
      single: true,
      multiple1: true,
      multiple3: false,
      multiple4: false,
      syncRequest: false
    },
    useOrderProducts: true, // utilizza i prodotti dell'ordine
    volumeFactor: ProductInputFactorEnum.L
  },
  panels: [
    {
      name: 'Autisti', iconCss: 'fas fa-user-tag', panel: 'panel-driver',
      options: { visible: false, panel: 'panel-driver' }, excelExport: "local", panelTitle: "none", order: 2,
      gridState: { take: 50, skip: 0, sort: [{ field: "fullname", dir: "asc" }, { field: "id", dir: "asc" }] }
    },
    {
      name: 'Ordini', iconCss: 'fas fa-shopping-cart', panel: 'panel-order',
      options: { visible: false, panel: 'panel-order' }, excelExport: "local", panelTitle: "nameOnly", order: 4,
      gridState: { take: 300, skip: 0, sort: [{ field: "requestedDeliveryDate", dir: "asc" }, { field: "id", dir: "asc" }] }
    },
    {
      name: 'Ricerca destinazioni', iconCss: 'fas fa-search-location', panel: 'panel-destination-search',
      options: { visible: false, panel: 'panel-destination-search', positionRatio: { left: 1 / 100, top: 1 / 50 } }, excelExport: "none", panelTitle: "none", order: 0,
      gridState: { take: 20, skip: 0 }
    },
    {
      name: 'Unità di trasporto', iconCss: 'fas fa-truck-moving', panel: 'panel-transportunit',
      options: { visible: false, panel: 'panel-transportunit' }, excelExport: "local", panelTitle: "none", order: 3,
      gridState: { take: 50, skip: 0, sort: [{ field: "tractorPlate", dir: "asc" }, { field: "trailerPlate", dir: "asc" }] }
    },
    {
      name: 'Viaggi', panel: 'panel-trip', iconCss: 'fas fa-location-arrow',
      options: { visible: false, panel: 'panel-trip' }, excelExport: "local", panelTitle: "none", order: 5,
      gridState: { take: 50, skip: 0, sort: [{ field: "id", dir: "asc" }] }
    },
    {
      name: 'OPT | Ordini esclusi', iconCss: 'fas fa-shopping-cart', panel: 'panel-optimizer-order',
      options: { visible: false, panel: 'panel-optimizer-order' }, excelExport: "local", panelTitle: "Ordini esclusi", order: 4,
      gridState: { take: 300, skip: 0, sort: [{ field: "requestedDeliveryDate", dir: "asc" }, { field: "id", dir: "asc" }] }
    },
    {
      name: 'OPT | Viaggi', panel: 'panel-optimizer-trip', iconCss: 'fas fa-location-arrow',
      options: { visible: false, panel: 'panel-optimizer-trip' }, excelExport: "local", panelTitle: "Viaggi", order: 5,
      gridState: { take: 50, skip: 0, sort: [{ field: "id", dir: "asc" }] }
    },
    {
      name: 'Baie di carico', panel: 'panel-loading-point', iconCss: 'fas fa-download',
      options: { visible: false, panel: 'panel-loading-point' }, excelExport: "local", panelTitle: "local", order: -1
    },
    {
      name: 'Disponibilità depositi', panel: 'panel-depot-availability', iconCss: 'fas fa-battery-half',
      options: { visible: false, panel: 'panel-depot-availability' }, excelExport: "local", panelTitle: "local", order: -2
    },
    {
      name: 'Conti di carico', iconCss: 'fas fa-wallet', panel: 'panel-load-account',
      options: { visible: false, panel: 'panel-load-account', positionRatio: { left: 1 / 100, top: 1 / 10 } }, excelExport: "local", panelTitle: "local", order: 1,
      gridState: { take: 20, skip: 0, sort: [{ field: "id", dir: "asc" }] }
    },
    {
      name: 'Parametri contratto vettori', iconCss: 'fas fa-calculator', panel: 'panel-contract-haulier-parameter',
      options: {
        visible: false, panel: 'panel-contract-haulier-parameter', positionRatio: { left: 1 / 100, top: 1 / 10 }
      },
      excelExport: "local",
      panelTitle: "local",
      order: -3,
      gridState: { take: 20, skip: 0, sort: [{ field: "haulierDescription", dir: "asc" }, { field: "issuingAuthorityDescription", dir: "asc" }] }
    },
  ],
  product: {
    getBy: 'id'
  },
  profile: {
    maxSelectableZone: 9999999  // Equivale a nessun limite
  },
  showInterdistanceId: false,
  toolbar: {
    kpiFromWebApi: false,
    reloadRouteOnDateChange: false
  },
  trip: {
    addDriverType: 'selected',
    addTransportUnitType: 'selected',
    addWarehouseEnabled: false,
    changeProductEnabled: false,
    changeTerminalEnabled: true,
    changeZoneEnabled: false,
    checkDriverShiftTime: "all",
    createEnabled: true,
    createShiftEnabled: false,
    defaultFirstTripColor: undefined,
    deleteEnabled: true,
    deviationEnabled: false,
    editEnabled: true,
    filterDriverByHaulier: false,
    hasGarage: true,
    groupable: true,
    multilevelProduct: false,
    optimizeEnabled: true,
    resetEnabled: false,
    revertStatusEnabled: false,
    selectAfterCreate: true,
    sendToDepotEnabled: false,
    sendToDriverEnabled: false,
    sendToHaulierEnabled: false,
    sendToSapEnabled: false,
    singleProductEnabled: false,
    stopAddDeliveryEnabled: false,
    stopAddEnabled: false,
    stopAddPauseEnabled: false,
    tripInfo: "panel",
    useShiftPerView: false,
    useTripProducts: true,
    validateEnabled: false,
    volumeFactor: ProductInputFactorEnum.L,
    /** Campi modificabili */
    editableFields: {
      contractId: false,  // Codice contratto
      contractTransportUnitId: false, // Codice unità di trasporto del contratto
      depotId: true, // Codice deposito di carico
      depot2Id: true, // Codice secondo deposito di carico
      depotReturnId: false, // Codice deposito di rientro
      driverId: true,  // Codice autista
      driver2Id: true, // Codice secondo autista
      flagFixedTripDateTime: true, // Flag orario fisso del viaggio
      garageId: false,  // Codice garage
      kmAdditional: true, // km aggiuntivi al viaggio
      loadStartDateTime: false, // Data/ora inizio carico
      note: true, // Note del viaggio
      sequence: false,  // Numero di sequenza
      shift: false, // Turno
      skipGarage: false,  // Ometti garage dal conteggio dei km
      status: false,  // Stato del viaggio
      tractorPlate: false,  // Targa motrice
      trailerPlate: false,  // Targa rimorchio
      transportUnitId: true, // Codice unità di trasporto
      tripStartDateTime: 'time', // Data/ora di partenza del viaggio
      warehouseId: false, // Codice magazzino
      zoneId: true,  // Codice della zona
      stopFields: {
        arrivalDateTime: true, // Data/ora di arrivo
        das: false, // DAS o eDAS
        destinationId: false, // Codice destinazione della fermata
        productQuantity: 'dialog', // Quantità del prodotto
        requestedDeliveryDate: false, // Data di consegna richiesta
        sequence: true,  // Numero di sequenza
        status: false,  // Stato
        stopTime: true // Durata della sosta/scarico
      }
    },
    route: {
      effectiveRouteEnabled: false,
      routeViewEnabled: false,
      showBorder: true,
    },
    stops: {
      addDefaultStartingInputType: 'date',
      addDeliveryBufferEnabled: false,
      addEnabled: false,
      deleteEnabled: true,
      deliveryOrderChangeEnabled: false,
      editableStopType: [TripStopTypeEnum.DELIVERY],
      exchangeEnabled: true,
      showUOM: false
    }
  },
  useLocalPlanningDate: true,
  usePlanningDate: 'single',
  zoom: 6,
};
